export default function LibraryCard({ inspiration, isDark, position, total, onOpen }) {
  const images = inspiration.images || [];
  const tags = inspiration.tags || [];
  const visibleTags = tags.slice(0, 3);
  const overflowCount = tags.length - visibleTags.length;
  const subtitle = (inspiration.design_types || []).slice(0, 2).join(' x ');

  return (
    <button
      type="button"
      onClick={onOpen}
      className={`group text-left rounded-lg overflow-hidden border transition-all duration-base ease-smooth active:scale-[0.99] ${
        isDark
          ? 'bg-background-dark/50 border-border-dark hover:border-primary-dark'
          : 'bg-white border-border hover:border-primary hover:shadow-md'
      }`}
    >
      <div className={`w-full aspect-[4/3] overflow-hidden ${isDark ? 'bg-border-dark' : 'bg-background-sidebar'}`}>
        {images.length > 0 ? (
          <img
            src={images[0].url}
            alt={inspiration.title}
            loading="lazy"
            className="w-full h-full object-cover transition-transform duration-slow ease-smooth group-hover:scale-105"
          />
        ) : (
          <div className={`w-full h-full flex items-center justify-center text-xs ${isDark ? 'text-gray-600' : 'text-text-light'}`}>
            No image
          </div>
        )}
      </div>

      <div className="p-4">
        <h3
          className={`text-base font-display font-semibold leading-snug ${
            isDark ? 'text-white' : 'text-text'
          }`}
        >
          {inspiration.title}
        </h3>

        {subtitle && (
          <p className={`text-xs mt-0.5 ${isDark ? 'text-gray-500' : 'text-text-light'}`}>
            {subtitle}
          </p>
        )}

        {visibleTags.length > 0 && (
          <div className="flex flex-wrap gap-1.5 mt-3">
            {visibleTags.map((tag) => (
              <span
                key={tag}
                className={`text-xs px-2 py-0.5 rounded ${
                  isDark ? 'bg-border-dark text-gray-300' : 'bg-background-sidebar text-text-muted'
                }`}
              >
                {tag}
              </span>
            ))}
            {overflowCount > 0 && (
              <span className={`text-xs px-2 py-0.5 rounded ${isDark ? 'text-gray-500' : 'text-text-light'}`}>
                +{overflowCount}
              </span>
            )}
          </div>
        )}

        <div className={`flex items-center justify-between mt-4 pt-3 border-t ${isDark ? 'border-border-dark' : 'border-border/50'}`}>
          <span className={`inline-flex items-center gap-1.5 text-xs font-medium ${isDark ? 'text-primary-dark' : 'text-primary'}`}>
            <span className={`w-1.5 h-1.5 rounded-full ${isDark ? 'bg-primary-dark' : 'bg-primary'}`} />
            {inspiration.niches?.[0] || inspiration.category}
          </span>
          <span className={`text-xs font-mono ${isDark ? 'text-gray-600' : 'text-text-light'}`}>
            {String(position).padStart(2, '0')} / {total}
          </span>
        </div>
      </div>
    </button>
  );
}
